import { Col } from "reactstrap";
import { H5 } from "../../../../AbstractElements";
import { SubtractiveBorderTitle } from "../../../../Constants/Constants";
import { AdditiveBorderData } from "../../../../Data/UiKits/HelperClasses";

const SubtractiveBorder = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H5 className="mb-3">{SubtractiveBorderTitle}</H5>
        {AdditiveBorderData &&
          AdditiveBorderData.map((item, index) => (
            <div className="helper-common-box" key={index}>
              <div className={`helper-box bg-light border ${item}-0`} />
              <span>{`.${item}-0`}</span>
            </div>
          ))}
      </div>
    </Col>
  );
};
export default SubtractiveBorder;
